import type { IconData } from '@stacksjs/iconify-core'

export const yahooCircle: IconData = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"M13.055 8.483c-.245.066-2.484 1.802-2.631 2.228c-.033.148.003 1.574.036 1.788c.147.033 1.212.005 1.408.037l-.024.441c-.191-.015-1.545-.011-2.317-.011c-.392 0-1.654.043-2.041.032l.073-.42c.213-.015 1.093.04 1.285-.166c.096-.102.066-1.458.034-1.688c-.082-.245-2.044-2.703-2.557-3.106H5V7h4.457v.043l.015.001l-.015.105v.469H8.113c.599.876 1.457 1.933 1.824 2.441l1.795-1.626h-1.067l-.15-.618h3.908l-.03.044l.015.001l-.28.405l-.008.001l-.113.167h-.721c-.093.02-.175.039-.231.05m1.275 3.87l-.345-.016l-.385-.047l.004.66l.303.026l.327.024zM15 9.2a28 28 0 0 1-1.313-.131l.017 2.788l.599.048z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default yahooCircle
